import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import { useState } from 'react';
import { discoverOnvif } from '../../domain/socketSlice';
import { useEffect } from 'react';
import { getEdgeResponse } from '../../maps/data.js';
import Connecting from '../Connecting';
import useZibi from "../../zibi/UseZibi";

export default function DiscoverOnvifDialog({ edgeId, onClose }) {
    const [camerasOnVif, set_camerasOnVif] = useZibi('camerasOnVif');

    useEffect(() => {
        if(camerasOnVif?.length === 0){
            const discover = async () => {
                const responseId = `${edgeId}-${new Date().getTime()}`;
                discoverOnvif({ edgeId, responseId });
                const response = await getEdgeResponse(responseId, 90)
                if (response?.length) {
                    set_camerasOnVif(response);
                }
            }
            discover();
        }
    }, []);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="sm"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <Tx>camera.discoverCamera.title</Tx>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 5 }}>

                {
                    !camerasOnVif.length ? <Connecting timer="90" onDone={()=>{
                        window.messageBox('Connection falied');
                        onClose(false);
                    }}/> : <div>
                        <Tx>camera.selectCameraIp</Tx>:
                        <div style={{marginTop: 10}}>
                            {camerasOnVif.map((onvif, idx) => {
                                return (
                                    <div
                                        key={idx}
                                        style={{marginBottom: 5}}
                                    >
                                        <Button
                                            onClick={() => onClose(onvif)
                                            }
                                            variant="outlined">{onvif.serial_number} [{onvif.ip}]</Button>
                                    </div>
                                );
                            })
                            }
                        </div>
                    </div>
                }

            </DialogContent>

            <DialogActions>

                <Button onClick={() => onClose(false)}><Tx>g.cancel</Tx></Button>

            </DialogActions>
        </Dialog >)
}